var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppWithLoading',{attrs:{"fetch":_vm.fetchVacancyAndRedirect}})}
var staticRenderFns = []

export { render, staticRenderFns }